import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
export function LandingPage() {
  const [showTerms, setShowTerms] = useState(false);
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-terracotta/20" data-id="element-118">
      <nav className="absolute top-0 left-0 w-full p-6 z-50" data-id="element-119">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-120">
          <div className="font-serif font-bold text-xl text-navy flex items-center gap-2" data-id="element-121">
            <span className="w-8 h-8 bg-navy text-cream rounded-full flex items-center justify-center text-sm" data-id="element-122">
              5
            </span>
            <span data-id="element-123">Minutos</span>
          </div>
        </div>
      </nav>

      <main data-id="element-124">
        <HeroSection data-id="element-125" />
        <ProblemSection data-id="element-126" />
        <SolutionSection data-id="element-127" />
        <AudienceSection data-id="element-128" />
        <PricingSection data-id="element-129" />
      </main>

      <footer className="bg-navy text-cream/40 py-12 text-center text-sm" data-id="element-130">
        <div className="max-w-6xl mx-auto px-6" data-id="element-131">
          <p className="mb-4" data-id="element-132">
            &copy; {new Date().getFullYear()} Kit 5 Minutos para Bajar la
            Ansiedad.
          </p>
          <p className="mb-4" data-id="element-133">
            Este producto no sustituye la terapia profesional ni el tratamiento
            médico.
          </p>
          <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 text-cream/60 hover:text-cream/80 transition-colors cursor-pointer" data-id="element-134">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Terms & Conditions Modal */}
      <AnimatePresence data-id="element-135">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-navy/60 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-136">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-137">
              <div className="sticky top-0 bg-cream border-b border-navy/10 px-8 py-5 flex items-center justify-between rounded-t-2xl" data-id="element-138">
                <h2 className="font-serif text-2xl font-bold text-navy" data-id="element-139">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="w-9 h-9 rounded-full bg-navy/5 hover:bg-navy/10 flex items-center justify-center transition-colors text-navy/60 hover:text-navy" data-id="element-140">
                  <X className="w-5 h-5" data-id="element-141" />
                </button>
              </div>

              <div className="px-8 py-6 space-y-6 text-navy/80 text-sm leading-relaxed" data-id="element-142">
                <section data-id="element-143">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-144">
                    1. Producto Digital
                  </h3>
                  <p data-id="element-145">
                    El "Kit 5 Minutos para Bajar la Ansiedad" es un producto
                    digital en formato PDF. Al completar la compra, recibirás
                    acceso inmediato al material descargable. Por tratarse de un
                    producto digital de entrega instantánea, no se aceptan
                    devoluciones una vez descargado el contenido, salvo lo
                    indicado en nuestra garantía de satisfacción.
                  </p>
                </section>

                <section data-id="element-146">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-147">
                    2. Garantía de Satisfacción
                  </h3>
                  <p data-id="element-148">
                    Ofrecemos una garantía de satisfacción de 7 días corridos
                    desde la fecha de compra. Si sentís que el producto no te
                    aporta valor, podés solicitar un reembolso completo sin
                    preguntas dentro de ese plazo.
                  </p>
                </section>

                <section data-id="element-149">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-150">
                    3. Uso Personal
                  </h3>
                  <p data-id="element-151">
                    El contenido del kit es para uso personal y privado. Queda
                    prohibida la reproducción, distribución, reventa o
                    publicación parcial o total del material sin autorización
                    expresa por escrito.
                  </p>
                </section>

                <section data-id="element-152">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-153">
                    4. Descargo de Responsabilidad
                  </h3>
                  <p data-id="element-154">
                    Este producto es una herramienta de autogestión emocional y{' '}
                    <strong data-id="element-155">no sustituye</strong> la consulta, diagnóstico o
                    tratamiento de un profesional de la salud mental. Si estás
                    atravesando una crisis severa o tenés síntomas médicos
                    nuevos, consultá con un profesional.
                  </p>
                </section>

                <section data-id="element-156">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-157">
                    5. Precio y Moneda
                  </h3>
                  <p data-id="element-158">
                    El precio publicado es en pesos uruguayos (UYU). Los precios
                    promocionales tienen vigencia limitada y pueden cambiar sin
                    previo aviso.
                  </p>
                </section>

                <section data-id="element-159">
                  <h3 className="font-bold text-navy text-base mb-2" data-id="element-160">
                    6. Propiedad Intelectual
                  </h3>
                  <p data-id="element-161">
                    Todo el contenido del kit (textos, diseños, protocolos,
                    tarjetas) está protegido por derechos de autor. La compra
                    otorga una licencia de uso personal, no transferible.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}